import React from "react";
import AutomatedMessageText from "../../AutomatedMessageText";

const AutomatedMessageModifyEnquiry = ({ thread, children }) => {
  // console.log({ children })
  return children ? (
    <AutomatedMessageText tagTitle="Updated Enquiry">
      {children}
    </AutomatedMessageText>
  ) : null;
};

export default AutomatedMessageModifyEnquiry;
